import { render, staticRenderFns } from "./question15.vue?vue&type=template&id=28972a1e&"
import script from "./question15.vue?vue&type=script&lang=js&"
export * from "./question15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports